import { render, staticRenderFns } from "./radio-preference-element.vue?vue&type=template&id=a0c3fe52"
import script from "./radio-preference-element.vue?vue&type=script&lang=js"
export * from "./radio-preference-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports